import LoadingButton from "@mui/lab/LoadingButton";
import { Autocomplete, Button, Checkbox, Dialog, DialogContent, DialogTitle, Grid, TextField } from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { requestOptions } from "../../../../../../Helpers/function";
import api from './../../../../../../Apis'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function FormSearch(props) {
    const [state, setState] = useState({
        fanpage_id: props.fanpage_id,
        dialog: false,
        loading_submit: false,
        fanpage_selected: []
    })

    const {register, handleSubmit, setValue, control, reset} = useForm();

    const handleChangeFanpage = (event, data) => {
        setState({
            ...state,
            fanpage_id: data.fanpage_id
        })
    }

    const search = () => {
        props.search(state.fanpage_id);
    }

    const splitFanpage = (data) => {
        data["fanpage_selected"] = state.fanpage_selected;
        setState({
            ...state,
            loading_submit: true
        })
        fetch(api.split_fanpage, requestOptions('POST', props.cookie, data))
        .then(res => res.json())
        .then(
            (result) => {
                if (result.success) {
                    Swal.fire({
                        title: result.message,
                        time: 2000,
                        icon: 'success'
                    })
                    props.updateGroupPage(result.group_pages);
                    setState({
                        ...state,
                        loading_submit: false,
                        dialog: false
                    })
                } else {
                    Swal.fire({
                        title: result.message,
                        time: 2000,
                        icon: 'warning'
                    })
                    setState({
                        ...state,
                        loading_submit: false,
                    })
                }
                
            }
        )
    }

    const onCheckedFanpage = (e, data) => {
        setState({
            ...state,
            fanpage_selected: data
        })
    }    
    return (
        <Grid container spacing={2}>
            <Dialog open={state.dialog} fullWidth="true" maxWidth='sm' onClose={() => {setState({...state, dialog: false})}}>
                <DialogTitle>Phân nhóm page</DialogTitle>
                <DialogContent>
                    <p>
                        <b style={{color: 'red'}}>Chú ý: </b> Việc phân nhóm page sẽ giúp bạn giảm thiểu trường hợp các bài viết không được publish lên Fanpage Facebook.
                    </p>
                    <p>
                        Tổng số Page hiện tại của bạn là <b>{props.data_api?.fanpages.length} page</b>
                    </p>
                    <form onSubmit={handleSubmit(splitFanpage)}>
                        <Grid container spacing={2} sx={{paddingBottom: "16px"}}>
                            <Grid item xs={12}>
                                <TextField {...register('group_name')} type="text" fullWidth  id="outlined-basic" label="Tên nhóm" variant="outlined" />
                            </Grid>
                            <Grid item xs={12}>
                                <Autocomplete
                                    multiple
                                    id="checkboxes-tags-demo"
                                    onChange={onCheckedFanpage}
                                    options={props.data_api?.fanpages}
                                    disableCloseOnSelect
                                    getOptionLabel={(option) => option.name}
                                    renderOption={(props, option, { selected }) => (
                                        <li {...props}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.name}
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Chọn Fanpage" placeholder="Chọn Fanpage" />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <LoadingButton className="text-transform" type="submit" size="large" fullWidth loading={state.loading_submit} variant="contained">
                                    Xác nhận phân nhóm
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
            </Dialog>
            <Grid item xs={2} md={3}>
                <Autocomplete
                    id="tags-outlined"
                    options={props.data_api?.fanpages}
                    getOptionLabel={(option) => option.name}
                    defaultValue={props.data_api.fanpage}
                    onChange={handleChangeFanpage}
                    filterSelectedOptions
                    size="small"
                    renderInput={(params) => (
                    <TextField
                        size="small"
                        {...params}
                        label="Chọn Fanpage"
                    />
                    )}
                />
                {/* <TextField
                    id="outlined-select-currency"
                    select
                    size="small"
                    fullWidth
                    label="Chọn Fanpage"
                    defaultValue={id}
                    {...registerSearch('fanpage_id')}
                >
                    {
                        state.data_api?.fanpages.map((value, index) => {
                            return (
                                <MenuItem value={value.fanpage_id}>{value.name}</MenuItem>
                            )
                        })
                    }
                </TextField> */}
                {/* <TextField select fullWidth size="small" id="outlined-basic" label="Chọn Fanpage" variant="outlined" /> */}
            </Grid>
            <Grid item xs={3} md={3}>
                <Button className="text-transform" onClick={search} type="submit" variant="contained" color="primary">Tìm kiếm</Button>
                <Button className="text-transform" sx={{marginLeft: '10px'}} onClick={() => setState({...state, dialog: true})} type="submit" variant="contained" color="success">Phân nhóm Page</Button>
            </Grid>
        </Grid>
    )
}